export default __webpack_public_path__ + "static/media/gallery_02.a50c23d0.jpg";